import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import HeroImg from "../../../assets/images/hero/hero.png";
import OutlinedButton from "../../../components/button/OutlinedButton";
import colors from "../../../theme/color/ColorTheme";

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  z-index: 1;
  opacity: 1;
  transition: opacity 0.4s ease-in-out;
  max-height: 700px;
  min-height: 400px;
`;
const Wrapper = styled.div`
  width: 100%;
  height: inherit;
  position: relative;
  cursor: pointer;
  &:hover {
    ${Overlay} {
      opacity: 0.6;
    }
    button {
      background-color: ${colors.backgroundPrimary};
      transition-duration: 0.6s;
      color: ${colors.textPrimary};
    }
  }
`;
const Container = styled.div`
  position: relative;
  width: 100%;

  img {
    width: 100%;
    max-height: 700px;
    min-height: 400px;
    height: auto;
    object-fit: cover;
  }
`;

const Info = styled.div`
  width: 100%;
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 2;
`;

function HeroImage() {
  const navigate = useNavigate();
  return (
    <Wrapper
      onClick={() => {
        navigate("/products/flag/latest");
      }}
    >
      <Container>
        <Info style={{ color: colors.backgroundPrimary }}>
          {/* <H1>WALLET FESTIVE COLLECTION 2025</H1> */}
          <OutlinedButton text={"Shop All"} style={{ width: "240px" }} />
        </Info>
        <Overlay />
        <img src={HeroImg} alt="hero" />
      </Container>
    </Wrapper>
  );
}

export default HeroImage;
